<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="pageTitle">
          <template v-slot:preview>
            <b-form>
              <b-row class="mb-4">
                <b-col md="5">
                  <label class="form-label">
                    Tên nhóm <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    size="sm"
                    v-model="model.name"
                    placeholder="Nhập tên nhóm AdHoc"
                    autocomplete="off"
                  ></b-form-input>
                </b-col>
                <b-col md="7">
                  <label class="form-label">Mô tả</label>
                  <b-form-input
                    size="sm"
                    v-model="model.description"
                    placeholder="Mô tả nhóm"
                    autocomplete="off"
                  ></b-form-input>
                </b-col>
              </b-row>

              <!-- Thêm sản phẩm / danh mục -->
              <div class="section-title">Sản phẩm / Danh mục trong nhóm</div>
              <b-row class="mb-3">
                <b-col md="3">
                  <label class="form-label">Tìm theo</label>
                  <b-form-select
                    size="sm"
                    v-model="searchType"
                    :options="searchTypeOptions"
                    value-field="id"
                    text-field="name"
                    @change="onSearchTypeChange"
                  ></b-form-select>
                </b-col>
                <b-col md="9">
                  <label class="form-label">
                    {{ isCategorySearch ? 'Danh mục' : 'Sản phẩm' }}
                  </label>
                  <Autosuggest
                    :key="'item-' + componentKey"
                    :model="searchText"
                    :suggestions="itemSuggestions"
                    :placeholder="
                      isCategorySearch
                        ? 'Nhập tên danh mục'
                        : 'Nhập tên hoặc mã sản phẩm'
                    "
                    :limit="10"
                    @select="onSelectItem($event)"
                    @change="onSearchItem($event)"
                    suggestionName="suggestionName"
                  />
                </b-col>
              </b-row>

              <b-table
                class="table-bordered table-hover mb-4"
                :fields="itemFields"
                :items="model.details"
                small
                show-empty
                empty-text="Chưa có sản phẩm / danh mục nào. Dùng ô tìm phía trên để thêm."
              >
                <template v-slot:cell(count)="row">
                  {{ row.index + 1 }}
                </template>
                <template v-slot:cell(type)="row">
                  <b-badge
                    :variant="
                      row.item.type === ITEM_TYPE.PRODUCT ? 'primary' : 'secondary'
                    "
                    >{{ itemTypeName(row.item.type) }}</b-badge
                  >
                </template>
                <template v-slot:cell(name)="row">
                  {{ row.item.name }}
                  <span v-if="row.item.code" class="text-muted">
                    ({{ row.item.code }})
                  </span>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    variant="link"
                    size="sm"
                    class="text-danger p-0"
                    @click="removeItem(row.index)"
                  >
                    <i class="flaticon2-rubbish-bin-delete-button"></i>
                  </b-button>
                </template>
              </b-table>

              <div class="mt-4">
                <b-button
                  variant="primary"
                  size="sm"
                  class="mr-2"
                  :disabled="isSaving"
                  @click="save"
                >
                  <i class="flaticon2-check-mark mr-1"></i>
                  {{ isSaving ? 'Đang lưu...' : 'Lưu' }}
                </b-button>
                <b-button variant="secondary" size="sm" @click="goBack">
                  Huỷ
                </b-button>
              </div>
            </b-form>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Tạo / cập nhật Nhóm AdHoc — SRS F-06.
 *
 * Cấu hình y hệt nhóm hoa hồng: mỗi item là Sản phẩm hoặc Danh mục.
 * Danh mục được nở ĐỆ QUY xuống mọi cấp con lúc engine tính.
 *
 * NT-3: dùng LẠI đúng API tìm kiếm mà nhóm hoa hồng đang dùng
 * (productSearch/search-by-product-category), không viết endpoint mới.
 */
import KTCodePreview from '@/view/content/CodePreview.vue';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import debounce from 'debounce';
import { TIME_TRIGGER } from '@/utils/constants';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';
import {
  COMMISSION_ADHOC_ITEM_TYPE,
  COMMISSION_ADHOC_ITEM_TYPE_NAME,
  COMMISSION_SEARCH_TYPE,
  toOptionList,
} from './commission.constants';
// thStyle nằm ở mixin của màn báo cáo — dùng lại, không tự viết
import { thStyle } from './commissionReport.mixin';

export default {
  components: { KTCodePreview, Autosuggest },
  data() {
    return {
      ITEM_TYPE: COMMISSION_ADHOC_ITEM_TYPE,
      componentKey: 0,
      isSaving: false,
      categoryId: null,
      model: { name: '', description: '', details: [] },
      searchType: COMMISSION_ADHOC_ITEM_TYPE.PRODUCT,
      searchText: '',
      itemSuggestions: [],
      searchTypeOptions: toOptionList(COMMISSION_ADHOC_ITEM_TYPE_NAME),
      itemFields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: thStyle('8%'),
          tdClass: 'text-center',
        },
        { key: 'type', label: 'Loại', thStyle: thStyle('16%') },
        { key: 'name', label: 'Tên', thStyle: thStyle('70%') },
        {
          key: 'actions',
          label: '',
          thStyle: thStyle('6%'),
          tdClass: 'text-center',
        },
      ],
    };
  },
  computed: {
    isCategorySearch() {
      return this.searchType === COMMISSION_ADHOC_ITEM_TYPE.CATEGORY;
    },
    pageTitle() {
      return this.categoryId ? 'Cập nhật nhóm AdHoc' : 'Tạo nhóm AdHoc';
    },
  },
  created() {
    this.categoryId = Number(this.$route.query.id) || null;
    if (this.categoryId) {
      this.fetchDetail();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hoa hồng', route: '/commission/categories' },
      { title: 'Nhóm AdHoc', route: '/commission/adhoc-categories' },
      { title: this.categoryId ? 'Cập nhật' : 'Tạo mới' },
    ]);
  },
  methods: {
    itemTypeName(type) {
      return COMMISSION_ADHOC_ITEM_TYPE_NAME[Number(type)] || '';
    },
    fetchDetail() {
      ApiService.setHeader();
      ApiService.query(`commission-adhoc-categories/${this.categoryId}`)
        .then(({ data }) => {
          const category = data.data || {};
          this.model = {
            name: category.name || '',
            description: category.description || '',
            details: (category.details || []).map((row) => ({
              type: Number(row.type),
              referenceId: row.referenceId,
              name: row.name || '',
              code: row.code || '',
            })),
          };
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không tải được nhóm'),
          );
        });
    },

    /* --------------------------- Tìm sản phẩm / danh mục -------------------- */
    onSearchTypeChange() {
      this.searchText = '';
      this.itemSuggestions = [];
      this.componentKey += 1;
    },
    onSearchItem(text) {
      this.searchText = text;
      this.debounceSearchItem(text, this.searchType);
    },
    debounceSearchItem: debounce(function (text, type) {
      if (!text) {
        this.itemSuggestions = [];
        return;
      }
      const typeSearch =
        Number(type) === COMMISSION_ADHOC_ITEM_TYPE.CATEGORY
          ? COMMISSION_SEARCH_TYPE.CATEGORY
          : COMMISSION_SEARCH_TYPE.PRODUCT;
      ApiService.setHeader();
      ApiService.get(
        `productSearch/search-by-product-category?searchProduct=${encodeURIComponent(
          text,
        )}&typeSearch=${typeSearch}&typeOfProduct=0`,
      )
        .then(({ data }) => {
          this.itemSuggestions = (data.data || []).map((item) => ({
            id: item.id,
            name: item.name || item.productName,
            code: item.code || '',
            suggestionName: item.code
              ? `${item.code} - ${item.name || item.productName}`
              : item.name || item.productName,
          }));
        })
        .catch(() => {
          this.itemSuggestions = [];
        });
    }, TIME_TRIGGER),
    onSelectItem(option) {
      const selected = option.item;
      const type = this.searchType;

      // Trùng thì bỏ qua — khớp UNIQUE KEY (nhóm, loại, referenceId) của bảng
      const existed = this.model.details.some(
        (row) =>
          Number(row.type) === Number(type) &&
          String(row.referenceId) === String(selected.id),
      );
      if (existed) {
        makeToastFaile('Sản phẩm / danh mục này đã có trong nhóm');
      } else {
        this.model.details.push({
          type,
          referenceId: String(selected.id),
          name: selected.name,
          code: selected.code,
        });
      }

      this.searchText = '';
      this.itemSuggestions = [];
      this.componentKey += 1;
    },
    removeItem(index) {
      this.model.details.splice(index, 1);
    },

    /* -------------------------------- Lưu ----------------------------------- */
    save() {
      const name = (this.model.name || '').trim();
      if (!name) {
        return makeToastFaile('Vui lòng nhập tên nhóm');
      }
      if (this.model.details.length === 0) {
        return makeToastFaile('Vui lòng chọn ít nhất một sản phẩm hoặc danh mục');
      }

      const payload = {
        name,
        description: this.model.description,
        details: this.model.details.map((row) => ({
          type: row.type,
          referenceId: row.referenceId,
        })),
      };

      this.isSaving = true;
      ApiService.setHeader();
      const request = this.categoryId
        ? ApiService.put(`commission-adhoc-categories/${this.categoryId}`, payload)
        : ApiService.post('commission-adhoc-categories', payload);

      request
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.goBack();
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không lưu được nhóm'),
          );
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    goBack() {
      this.$router.push({ name: 'commission-adhoc-categories' });
    },
  },
};
</script>

<style scoped>
.form-label {
  display: block;
  font-size: 12px;
  color: #7e8299;
  margin-bottom: 4px;
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #181c32;
  padding-bottom: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #ebedf3;
}
</style>
